import { AssigneeType, DocumentPropertyValue } from 'api/clients/PropertyClient'
import { MentionPrompt, ObjectsToLoad } from 'proseShared/prompts/MentionPrompt/MentionPrompt'
import { useState } from 'react'
import { ArticleFlat } from 'types'
import { PropertySearch } from '../../PropertySearch/PropertySearch'
import Styles from '../PropertyValue.module.scss'

interface Props {
  assignee?: {
    id: string
    type: AssigneeType
  }
  onSelect: (propertyValues: DocumentPropertyValue[]) => void
  onCancel: () => void
}

const DocumentEdit = ({ assignee, onSelect, onCancel }: Props) => {
  const [inputQuery, setInputQuery] = useState('')

  return (
    <div className={Styles.mentionEditContainer}>
      <div className={Styles.heading}>Value</div>
      <PropertySearch
        className={Styles.searchWrapper}
        placeholder={'Find a document...'}
        query={inputQuery}
        onChange={setInputQuery}
        onCancel={onCancel}
      />
      <div className={Styles.resultsList}>
        <MentionPrompt
          inputQuery={inputQuery}
          mentioningArticle={
            assignee &&
            ({
              id: assignee.id,
            } as ArticleFlat)
          }
          suggestRecentlyReadArticle={true}
          allowCreateNewFile={true}
          onSelect={(article) => onSelect([{ id: article.key } as DocumentPropertyValue])}
          onCancel={() => {}}
          dropdownWidth={'288px'}
          objectsToLoad={[ObjectsToLoad.Articles]}
        />
      </div>
    </div>
  )
}

export default DocumentEdit
